import FileUpload from "../../waterSystem/notes/FileUpload/FileUpload";
import { useUser } from "../../../context/UserContext";

export const ImportFilesBaseStructure = ({
  title,
  sampleFileInfo,
  sampleFilePath,
  sampleFileText,
  inputFile,
  import_type,
  setInputFile,
  setFormData,
  setResponse,
  mutation,
}) => {
  const acceptedFiles = ["text/csv", "application/vnd.ms-excel"];
  const { userInfo } = useUser();
  const { user_email } = userInfo;

  const deleteFile = () => {
    setInputFile({ name: "" });
    setResponse({});
  };

  const onUploadFile = (event) => {
    const { _, files } = event.target;
    let formData = new FormData();
    if (files[0]) {
      const fileType = files[0].type;
      if (acceptedFiles.includes(fileType)) {
        setInputFile({ name: files[0].name });
        formData.append("file", files[0]);
        formData.append("import_type", import_type);
        formData.append("import_by", user_email);
        setFormData(formData);
        mutation.mutate(formData);
      } else {
        alert("File type not allowed. Please upload a valid CSV file.");
        event.target.value = ""; // Clear the file input
      }
    } else {
      deleteFile();
    }
  };
  return (
    <>
      <div className="text-left mb-2">
        <label className="text-primary font-bold mb-5 mr-4 w-30 lg:mb-0">
          {title}
        </label>
        <div>
          <i className="text-sm text-accent ">
            {sampleFileInfo} <br />
            Import File Template:{" "}
            <a
              href={sampleFilePath}
              target="_blank"
              className="cursor-pointer text-secondary underline"
            >
              {sampleFileText}
            </a>
          </i>
        </div>
      </div>
      <FileUpload
        selectedFile={inputFile.name}
        name="importFile"
        handleFileChange={onUploadFile}
        deleteFile={deleteFile}
        deleteFileText={"Remove File"}
        loading={mutation?.isPending}
      />
    </>
  );
};
